import { css } from '@emotion/react'
import { Theme, useTheme } from 'bold-ui'

export function ConsultaSeguimentoStatusRespondendoIcon() {
  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <div css={styles.activeIconContainer}>
      <div css={styles.activeIcon} />
    </div>
  )
}

const createStyles = (theme: Theme) => ({
  activeIconContainer: css`
    width: 1rem;
    padding-top: 0.188rem;
    padding-left: 0.188rem;
  `,
  activeIcon: css`
    width: 0.667rem;
    height: 0.667rem;
    border-radius: 50%;
    background: ${theme.pallete.primary.main};
    box-shadow: 0 0 0 1px ${theme.pallete.surface.background}, 0 0 0 3px ${theme.pallete.primary.main};
  `,
})
